import { call, takeLatest, put } from 'redux-saga/effects';
import { message } from 'antd';
import {
  ADD_ADMIN_REQUEST,
  GET_ADMINS,
  addAdmin,
  setAdmins,
  setLoading,
  DELETE_ADMIN_REQUEST,
  deleteAdmin,
} from '../../actions/admin';

import {
  addAdminApi,
  deleteAdminApi,
  getAdminApi,
} from '../../../services/api/admin';

function* setAdminsAsync() {
  try {
    yield put(setLoading(true));
    const { response, data } = yield call(getAdminApi);

    if (response.ok && data) {
      yield put(setAdmins(data));
    } else {
      message.error('Une erreur est survenue');
    }
  } catch (e) {
    console.error(e);
  }
  yield put(setLoading(false));
}

function* addAdminAsync({ data: { body, callback } }) {
  try {
    yield put(setLoading(true));
    const response = yield call(addAdminApi, body);
    if (response.data) {
      yield put(addAdmin(response.data));
    }
    callback(response.response);
  } catch (e) {
    console.error(e);
  }

  yield put(setLoading(false));
}

function* deleteAdminAsync({ data: { id, callback } }) {
  try {
    yield put(setLoading(true));
    const response = yield call(deleteAdminApi, id);
    if (response.data) {
      yield put(deleteAdmin(id));
      callback(response.response.status);
    }
  } catch (e) {
    console.error(e);
  }
  yield put(setLoading(false));
}

export function* setAdminsSaga() {
  yield takeLatest(GET_ADMINS, setAdminsAsync);
}

export function* addAdminSaga() {
  yield takeLatest(ADD_ADMIN_REQUEST, addAdminAsync);
}

export function* deleteAdminSaga() {
  yield takeLatest(DELETE_ADMIN_REQUEST, deleteAdminAsync);
}
